import React from 'react';


export default class Collage extends React.Component {
  render (){
    return (
      <div className="collage-wrapper">
        <div className="join-collage">
          <div className="join-collageText global-banner-text">
            <h2>
              {this.props.title || 'Join us to receive special member-only benefits...'}
            </h2>
            <p className="tag">{this.props.subtitle || 'Build your profile, tell us your interests & connect with amazing resources'}</p>
          </div>

        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Collage.jsx